<template>
    <div id="app">
        <main-menu></main-menu>
        <transition name="fade">
            <router-view></router-view>
        </transition>
        <footer></footer>
    </div>
</template>

<script>

export default {
    name: 'App',
    data () {
        return {

        }
    }
}
</script>



// WEBPACK FOOTER //
// App.vue?50daffe6